<!-- Lista de mensajes -->
<div class="messages-list" #messagelist
     *ngIf="!loadingMessages && messages && messages.length > 0">
    <div *ngFor="let item of messages">
        <app-event-messenger-message [message]="item" [data]="data"></app-event-messenger-message>
    </div>
</div>

<!-- Estado vacío -->
<div class="messages-empty"
     *ngIf="!loadingMessages && (!messages || messages.length === 0)">
    <span class="messages-empty-icon" aria-hidden="true">
        <svg viewBox="0 0 32 32" fill="none" stroke="#00558c"
             stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M28 18a3 3 0 0 1-3 3H12l-6 5V8a3 3 0 0 1 3-3h16a3 3 0 0 1 3 3z"/>
        </svg>
    </span>
    <p class="messages-empty-title">No hay mensajes</p>
    <p class="messages-empty-helper">
        Comienza la conversación con tu tramitador. Presiona ENTER para empezar.
    </p>
</div>

<!-- Loading -->
<div class="messages-loading" *ngIf="loadingMessages">
    <p>Cargando<span>.</span><span>.</span><span>.</span></p>
</div>
